import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './button.component';
import { ProductLabelComponent } from '../product-label';
import { A11yLinkDirective } from '../../helper/directives/a11ylink.directive';



@NgModule({
  declarations: [ButtonComponent],
  imports: [A11yLinkDirective, CommonModule, ProductLabelComponent],
  exports: [ButtonComponent]
})
export class ButtonModule {}
